<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limit
-->

<div *ngIf="isImporting; else defaultView">
  <h2 mat-dialog-title>
    <ng-container i18n="@@app.dialogs.importSites.importingSites"
      >Importing sites...</ng-container
    >
  </h2>
  <mat-dialog-content>
    <div class="progress-spinner">
      <mat-spinner mode="indeterminate" class="spinner"></mat-spinner>
    </div>
  </mat-dialog-content>
</div>
<ng-template #defaultView>
  <h2 mat-dialog-title>
    <ng-container i18n="@@app.dialogs.importSites.title"
      >Import data collection sites (.geojson)</ng-container
    >
  </h2>
  <mat-dialog-content>
    <p
      class="format-description"
      i18n="@@app.dialogs.importSites.formatDescription"
    >
      Upload a GeoJSON <code>FeatureCollection</code>. Coordinates must use the
      WGS84 (CRS84) coordinate reference system, the only projection currently
      supported. Each feature's <code>name</code> property sets the site name,
      and the feature's top-level <code>id</code> sets the site ID.
    </p>
    <form [formGroup]="uploadForm">
      <div>
        <file-upload
          accept="{{ acceptedExtensions }}"
          formControlName="file"
          multiple="false"
          minsize="10 B"
          maxsize="2 MB"
        ></file-upload>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>
      <ng-container i18n="@@app.labels.cancel">Cancel</ng-container>
    </button>
    <button mat-button color="primary" (click)="onImportLocationsOfInterest()">
      <ng-container i18n="@@app.labels.upload">Upload</ng-container>
    </button>
  </mat-dialog-actions>
</ng-template>
